import axios from 'axios';
import { UserModel, OtpCodeModel } from '../types';
import './axios-interceptor';

export default {
  async createUser(user: UserModel) {
    return await axios.post(`user/register`, user);
  },

  async getUser() {
    return await axios.post(`user/profile`);
  },

  async updateUser(user: UserModel) {
    return await axios.put(`user/profile`, user);
  },

  async getOtp(user: OtpCodeModel) {
    return await axios.post(`user/otp`, user);
  },
};
